import { render, staticRenderFns } from "./ShippoFeeAmount.vue?vue&type=template&id=19581016&"
import script from "./ShippoFeeAmount.vue?vue&type=script&lang=ts&"
export * from "./ShippoFeeAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports